import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Floor10Component = ({unitStatus}) => {
  console.log('unitStatus', unitStatus);
    useEffect(() => {
        // Initialize ImageMapPro after the component mounts
        const initializeImageMap = () => {
            if (window.ImageMapPro) {
                window.ImageMapPro.init('#image-map-pro', {
                  "id": "2604a0af-e835-45da-bf61-16a6cf5c6059", "general": {
    "name": "Floor 8,10,12"
}, "artboards": [{
"background_type": "image",
"image_url": "https://greendirectorydata.s3.us-east-2.amazonaws.com/GPP8%20KP%205-%208th%2C%2010th%2C%2012th%20FLOOR%20copy.png",
"width": 3810,
"height": 2620,
"use_image_size": true,
"children": [{
    "id": "add804b2-526e-434d-af78-e27e10c5ba5c",
    "title": "Poly",
    "type": "poly",
    "x": 56.76258992805755,
    "y": 2.1904518370036796,
    "width": 10.287769784172667,
    "height": 50.11230710088418,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[6].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[6].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[6].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[6] && unitStatus[6].status
            ? `<a href="${unitStatus[6].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/10/7' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[6].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[6].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/10/7';"
    // },
    "x_image_background": 56.76258992805755,
    "y_image_background": 2.1904518370036796,
    "points": [{
        "x": 97.9020979020979,
        "y": 0.20876826722338201
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0,
        "y": 94.98956158663883
    }, {
        "x": 13.286713286713287,
        "y": 94.98956158663883
    }, {
        "x": 14.685314685314685,
        "y": 100
    }, {
        "x": 46.85314685314685,
        "y": 100
    }, {
        "x": 47.55244755244755,
        "y": 95.4070981210856
    }, {
        "x": 100,
        "y": 95.19832985386222
    }]
}, {
    "id": "4e68e722-3a46-4930-bcb7-46d67d0dc759",
    "title": "Poly",
    "type": "poly",
    "x": 66.83453237410072,
    "y": 2.1904518370036796,
    "width": 10.935251798561154,
    "height": 50.32154429128453,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[5].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[5].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[5].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[5] && unitStatus[5].status
            ? `<a href="${unitStatus[5].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/10/6' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[5].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[5].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/10/6';"
    // },
    "x_image_background": 66.83453237410072,
    "y_image_background": 2.1904518370036796,
    "points": [{
        "x": 100,
        "y": 0
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0,
        "y": 94.8024948024948
    }, {
        "x": 48.68421052631579,
        "y": 94.5945945945946
    }, {
        "x": 50,
        "y": 99.7920997920998
    }, {
        "x": 78.94736842105263,
        "y": 100
    }, {
        "x": 78.94736842105263,
        "y": 94.8024948024948
    }, {
        "x": 94.73684210526315,
        "y": 94.8024948024948
    }, {
        "x": 92.76315789473685,
        "y": 37.00623700623701
    }, {
        "x": 100,
        "y": 36.590436590436596
    }]
}, {
    "id": "1b36f2b7-900f-48b3-b9fe-2b2617358c04",
    "title": "Poly",
    "type": "poly",
    "x": 66.11510791366906,
    "y": 60.56762795870174,
    "width": 32.80575539568345,
    "height": 36.51188972486133,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[4].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[4].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[4].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[4] && unitStatus[4].status
            ? `<a href="${unitStatus[4].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/10/5' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[4].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[4].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/10/5';"
    // },
    "x_image_background": 66.11510791366906,
    "y_image_background": 60.56762795870174,
    "points": [{
        "x": 0,
        "y": 0.28653295128939826
    }, {
        "x": 0,
        "y": 79.65616045845272
    }, {
        "x": 12.06140350877193,
        "y": 79.65616045845272
    }, {
        "x": 12.06140350877193,
        "y": 99.7134670487106
    }, {
        "x": 50.21929824561403,
        "y": 99.14040114613181
    }, {
        "x": 50.43859649122807,
        "y": 79.36962750716332
    }, {
        "x": 64.03508771929825,
        "y": 79.08309455587393
    }, {
        "x": 64.03508771929825,
        "y": 99.7134670487106
    }, {
        "x": 82.89473684210526,
        "y": 100
    }, {
        "x": 82.45614035087719,
        "y": 79.36962750716332
    }, {
        "x": 94.95614035087719,
        "y": 79.94269340974212
    }, {
        "x": 94.73684210526315,
        "y": 34.097421203438394
    }, {
        "x": 100,
        "y": 34.38395415472779
    }, {
        "x": 99.56140350877193,
        "y": 0
    }]
}, {
    "id": "5fe913fb-8996-48da-8f45-5de410a1dbe7",
    "title": "Poly",
    "type": "poly",
    "x": 35.03597122302158,
    "y": 60.46300936350156,
    "width": 31.02517985611511,
    "height": 36.51188972486134,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[3].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[3].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[3].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[3] && unitStatus[3].status
            ? `<a href="${unitStatus[3].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/10/4' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[3].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[3].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/10/4';"
    // },
    "x_image_background": 35.03597122302158,
    "y_image_background": 60.46300936350156,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 0,
        "y": 99.71346704871064
    }, {
        "x": 20.17391304347827,
        "y": 100
    }, {
        "x": 20.405797101449263,
        "y": 79.6561604584527
    }, {
        "x": 46.14492753623189,
        "y": 79.6561604584527
    }, {
        "x": 46.84057971014492,
        "y": 100
    }, {
        "x": 86.72463768115945,
        "y": 99.71346704871064
    }, {
        "x": 86.72463768115945,
        "y": 80.22922636103152
    }, {
        "x": 100,
        "y": 79.58452743816937
    }, {
        "x": 99.71014492753622,
        "y": 0.5730659025787962
    }]
}, {
    "id": "fca9d979-4d45-446d-9245-dd215461554f",
    "title": "Poly",
    "type": "poly",
    "x": 3.6690647482014387,
    "y": 60.46300936350156,
    "width": 31.294964028776977,
    "height": 36.616508320061506,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[2].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[2].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[2].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[2] && unitStatus[2].status
            ? `<a href="${unitStatus[2].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/10/3' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[2].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[2].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/10/3';"
    // },
    "x_image_background": 3.6690647482014387,
    "y_image_background": 60.46300936350156,
    "points": [{
        "x": 0.9195402298850575,
        "y": 0.8571428571428572
    }, {
        "x": 0,
        "y": 79.71428571428572
    }, {
        "x": 12.873563218390805,
        "y": 79.71428571428572
    }, {
        "x": 13.10344827586207,
        "y": 100
    }, {
        "x": 54.252873563218394,
        "y": 99.71428571428571
    }, {
        "x": 54.48275862068965,
        "y": 79.42857142857143
    }, {
        "x": 80.22988505747126,
        "y": 79.42857142857143
    }, {
        "x": 80.45977011494253,
        "y": 99.71428571428571
    }, {
        "x": 100,
        "y": 99.14285714285714
    }, {
        "x": 99.77011494252874,
        "y": 0
    }]
}, {
    "id": "b7f39b64-5327-45d0-b51e-edde56a26ac1",
    "title": "Poly",
    "type": "poly",
    "x": 13.02158273381295,
    "y": 2.085833241803504,
    "width": 10.647482014388489,
    "height": 50.53078148168488,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[1].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[1].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[1].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[1] && unitStatus[1].status
            ? `<a href="${unitStatus[1].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/10/2' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[1].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[1].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/10/2';"
    // },
    "x_image_background": 13.02158273381295,
    "y_image_background": 2.085833241803504,
    "points": [{
        "x": 100,
        "y": 0
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0.6756756756756757,
        "y": 27.32919254658385
    }, {
        "x": 5.405405405405405,
        "y": 27.74327122153209
    }, {
        "x": 5.405405405405405,
        "y": 94.61697722567288
    }, {
        "x": 19.594594594594593,
        "y": 94.20289855072464
    }, {
        "x": 19.594594594594593,
        "y": 100
    }, {
        "x": 50,
        "y": 99.79296066252587
    }, {
        "x": 50,
        "y": 94.61697722567288
    }, {
        "x": 100,
        "y": 95.03105590062113
    }]
}, {
    "id": "9abaa8c1-0b72-43ff-9537-386f9b0618ed",
    "title": "Poly",
    "type": "poly",
    "x": 23.81294964028777,
    "y": 2.1904518370036796,
    "width": 10.71942446043166,
    "height": 50.32154429128453,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[0].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[0].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[0].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[0] && unitStatus[0].status
            ? `<a href="${unitStatus[0].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/10/1' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[0].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[0].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/10/1';"
    // },
    "x_image_background": 23.741007194244602,
    "y_image_background": 2.1904518370036796,
    "points": [{
        "x": 100,
        "y": 0
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0,
        "y": 94.8024948024948
    }, {
        "x": 50.33557046979866,
        "y": 94.38669438669439
    }, {
        "x": 50.33557046979866,
        "y": 100
    }, {
        "x": 79.19463087248322,
        "y": 99.7920997920998
    }, {
        "x": 80.53691275167785,
        "y": 94.8024948024948
    }, {
        "x": 95.9731543624161,
        "y": 95.01039501039502
    }, {
        "x": 93.95973154362416,
        "y": 21.413721413721415
    }, {
        "x": 100,
        "y": 21.205821205821206
    }]
}]
}], "version": "6.0.20"
});
            }
        };

        // Wait for the script to load
        const script = document.createElement('script');
        script.src = '/js/image-map-pro.min.js';
        script.onload = initializeImageMap;
        document.head.appendChild(script);
    }, []);

    return (
        // <div>
        //     <div id="image-map-pro"></div>
        // </div>
        <div justifyContent="center" alignItems="center">
          {/* Responsive container for the image map */}
          <div width={{ base: '100%', md: '80%' }} height={{ base: '300px', md: '400px' }} position="relative">
            {/* Ensure the image map fills its parent container */}
            <div id="image-map-pro" height="100%" width="100%"></div>
          </div>
        </div>
    );
}

export default Floor10Component;
